import React from "react";
import "../Css/Loader.css";
import logo from "../assets/svk-maid-logo.png"; // Make sure your logo path is correct

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        {/* The spinning ring */}
        <div className="loader-ring"></div>
        {/* Your Logo in the center */}
        <img src={logo} alt="Tanya Logo" className="loader-logo" />
      </div>
    </div>
  );
};

export default Loader;